import React from "react";
import {Col, Row } from "reactstrap";
import {compose, withHandlers} from "recompose";
import shortid from "shortid";
import {Trans} from "react-i18next";
import {getStatus, FormGroup, onMount, Page, withLocalForm, getType} from "components/common";
import { SpanColor, cStyle, formatDate as formatedDate } from "services/util";
import { LineItemsView } from "components";
import BackButton from "components/refactoring/BackButton";
import { Link } from "react-router-dom";

export const Overpayments = ({
  item,
  LocalForm,
  xero,
  dispatch,
  organisation,
  t,
}) => {

  return (
    <div className="nw-invoiceStyle">
    <Page
      title={t(`Overpayment for ${item.Contact.Name}`)}>
      <BackButton />
      <LocalForm className="mt-3 inv-table">
        <Row>
          <Col {...cStyle.common}>
            <FormGroup label="Contact" model=".Name" >
              <Link to={`/contacts/view/${item.Contact.ContactID}`} {...cStyle.status}>
                  {item.Contact.Name}
              </Link>
            </FormGroup>
          </Col>
          <Col {...cStyle.common}>
            <FormGroup label="Status">
            <SpanColor>{getStatus(item.Status)}</SpanColor>
            </FormGroup>
          </Col>
          <Col {...cStyle.common}>
            <FormGroup label="Date" model=".Date">
              <SpanColor>{formatedDate(item.Date) || "---"}</SpanColor>
            </FormGroup>
          </Col>
          <Col {...cStyle.common}>
            <FormGroup label="Type">
               <SpanColor>{getType(item.Type) || "---"}</SpanColor>
              </FormGroup>
            </Col>
          <Col {...cStyle.full}>
            <FormGroup label="Overpayment ID">
            <SpanColor>{item.OverpaymentID}</SpanColor>
            </FormGroup>
          </Col>
        </Row>
        <hr />
        <LineItemsView
          organisation={organisation}
          item={item}
          dispatch={dispatch}
          xero={xero}
          hideAddLines={true}
          hideAccountAndTax={false}
          invoiceType= "Overpayment"
        />
      </LocalForm>
    </Page>
  </div>
);
};

const enhance = compose(
  onMount(({ match, xero }) => async () => {
    const { id } = match.params
    const item = await xero
      .get(`overpayments/${id}`)
      .get("data")
      .then((item) => ({
        ...item,
        LineItems: item.LineItems.map((i) => ({
          ...i,
          _id: shortid(),
        })),
      }));

    return {
      item,
    };
  }),
  withLocalForm({
    initialState: ({ item }) => item,
    stateKey: "item",
    formKey: "form",
  }),
);

export default enhance(Overpayments);